import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "saiken-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#saiken-panel",
      role: "tab",
      "aria-controls": "saiken-panel"
    }, "債権")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "other-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#other-panel",
      role: "tab",
      "aria-controls": "other-panel"
    }, "その他")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "saiken-panel",
  role: "tabpanel",
  "aria-labelledby": "saiken-tab"
}
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "mt-3 float-right" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  class: "tab-pane fade",
  id: "other-panel",
  role: "tabpanel",
  "aria-labelledby": "other-tab"
}
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { class: "mt-3 float-right" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kaikei_kijun_setting_title = _resolveComponent("kaikei-kijun-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_yukashouken_setting_saiken_item = _resolveComponent("yukashouken-setting-saiken-item")!
  const _component_yukashouken_setting_other_item = _resolveComponent("yukashouken-setting-other-item")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_kaikei_kijun_setting_title, { "main-title": "有価証券明細表" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          loading: _ctx.loading,
          disabled: !_ctx.isAllValid,
          onClick: _ctx.onClickRegister
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedRequest,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saikenItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_yukashouken_setting_saiken_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.saikenItems.length - 1),
                  onUpItem: _cache[0] || (_cache[0] = (v) => _ctx.upItem('Saiken', v)),
                  onDownItem: _cache[1] || (_cache[1] = (v) => _ctx.downItem('Saiken', v)),
                  onTrashItem: _cache[2] || (_cache[2] = (v) => _ctx.trashItem('Saiken', v)),
                  onChangeInput: _cache[3] || (_cache[3] = (v) => _ctx.onChangeInput('Saiken', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addItem('Saiken'))),
                disabled: _ctx.saikenItems.length >= 10
              }, "項目を追加", 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherItems, (item, index) => {
                return (_openBlock(), _createBlock(_component_yukashouken_setting_other_item, {
                  key: item.item.id,
                  item: item,
                  "is-first": index === 0,
                  "is-last": index === (_ctx.otherItems.length - 1),
                  onUpItem: _cache[5] || (_cache[5] = (v) => _ctx.upItem('Other', v)),
                  onDownItem: _cache[6] || (_cache[6] = (v) => _ctx.downItem('Other', v)),
                  onTrashItem: _cache[7] || (_cache[7] = (v) => _ctx.trashItem('Other', v)),
                  onChangeInput: _cache[8] || (_cache[8] = (v) => _ctx.onChangeInput('Other', v))
                }, null, 8, ["item", "is-first", "is-last"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-primary",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addItem('Other'))),
                disabled: _ctx.otherItems.length >= 10
              }, "項目を追加", 8, _hoisted_12)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}